export const RESET_STATE = 'RESET-STATE'
export const SET_DELIVERY_DAYS_LIST = 'SET_DELIVERY_DAYS'
export const IS_LOADING = 'IS-LOADING'
export const SET_PACK_PROPERTIES = 'SET_PACK_PROPERTIES'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_PROMO_FILTERS = 'SET_PROMO_FILTERS'
export const SET_UNAUTHORIZED_FILTERS = 'SET_UNAUTHORIZED_FILTERS'
export const SET_APPLIED_UNAUTHORIZED_FILTERS = 'SET_APPLIED_UNAUTHORIZED_FILTERS'
export const SET_UNAUTHORIZED_LAST_FILTER_IDS = 'SET_UNAUTHORIZED_LAST_FILTER_IDS'
export const SET_MAX_ACTIVE_FILTERS_COUNT = 'SET_MAX_ACTIVE_FILTERS_COUNT'
export const SET_PROPOSED_FILTERS_VERSION = 'SET_PROPOSED_FILTERS_VERSION'
export const SET_UPDATE_FILTERS_MODAL_VISIBLE = 'SET_UPDATE_FILTERS_MODAL_VISIBLE'
